import { Converter } from '@opten/renderer';

export interface RadioButtonItem {
	name: string;
	value: string;
	selected: boolean;
}

export class CustomInputConverter implements Converter {
	fieldType = 'input';

	apply(element: HTMLElement, value: string | number | Date | RadioButtonItem) {
		if (value !== undefined && value !== 'undefined' && value !== null) {
			let oldValue: string | boolean | number | Date;
			let newValue: string | boolean | number | Date = value + '';
			switch (element.tagName.toLowerCase()) {
				case 'select':
					const selectElement = element as HTMLSelectElement;
					oldValue = selectElement.value;
					selectElement.value = newValue;
					this._handleInputValueSet(selectElement, oldValue, newValue);
					break;
				case 'option':
					const optionElement = element as HTMLOptionElement;
					const selectWrapper = optionElement.parentElement as HTMLSelectElement;
					oldValue = optionElement.value;
					optionElement.value = newValue;
					this._handleInputValueSet(selectWrapper, optionElement.value, newValue);
					/*if (selectWrapper && selectWrapper.value !== undefined && selectWrapper.value == value) {
						optionElement.selected = true;
						optionElement.setAttribute('selected', 'selected');
					}*/
					if ((element as any).optenRendererDataModel && (element as any).optenRendererDataModel.selected) {
						optionElement.selected = true;
						optionElement.setAttribute('selected', 'selected');
						selectWrapper.selectedIndex = (element as any).optenRendererDataModel.$index || 0;
					}
					break;
				default:
					const inputElement = element as HTMLInputElement;
					switch (inputElement.type) {
						case 'checkbox':
							const smallValue = value.toString().toLowerCase();
							const checkedValue = smallValue === 'true' || smallValue === '1' || smallValue === 'checked';
							oldValue = inputElement.checked;
							inputElement.checked = checkedValue;
							this._handleInputValueSet(inputElement, oldValue, checkedValue);
							break;
						case 'radio':
							const radioButton = value as RadioButtonItem;
							oldValue = inputElement.value;
							newValue = radioButton.value.toString().toLowerCase();
							inputElement.value = newValue;
							inputElement.checked = radioButton.selected;
							this._handleInputValueSet(inputElement, oldValue, newValue);
							break;
						case 'date':
							oldValue = inputElement.value;
							if (value.constructor.name === 'Date') {
								newValue = (value as Date).toISOString().split('T')[0];
							} else if (value.constructor.name === 'String') {
								newValue = (value as string).substring(0, 10);
							}
							inputElement.value = newValue;
							this._handleInputValueSet(inputElement, oldValue, newValue);
							break;
						default:
							oldValue = inputElement.value;
							inputElement.value = newValue;
							this._handleInputValueSet(inputElement, oldValue, newValue);
					}
					break;
			}
		}
	}

	private _handleInputValueSet(
		element: HTMLElement,
		oldValue: string | boolean | number | Date,
		newValue: string | boolean | number | Date
	): void {
		if ((oldValue && newValue && oldValue !== newValue) || (!oldValue && newValue) || (oldValue && !newValue)) {
			const event = document.createEvent('HTMLEvents');
			event.initEvent('change', false, true);
			element.dispatchEvent(event);
		}
	}
}
